import { useEffect, useState } from "react";
import { api } from "../../../../helpers/api";
import { PopupModal } from "../../../../components/PopupModal";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/x.svg";
import { useQuery } from "@tanstack/react-query";
import Checkbox from "../../../../components/Checkbox";
import RadioButton from "../../../../components/RadioButton";
import { Button } from "../../../../components/Button/Button";

export function ChangeTypeForm({
  onUpdate,
  onClose,
  user,
}: {
  onUpdate: () => void;
  onClose: () => void;
  user: any;
}) {
  const [form, setForm] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async () => {
    setLoading(true);
    console.log(form);
    const data: any = {
      id: user?.id,
      userType: form?.userType,
    };
    api
      .updateUserInfo(user?.id, data)
      .then((res) => {
        console.log(res);
        setLoading(false);
        onUpdate && onUpdate();
        handleClose();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleClose = () => {
    setForm({});
    onClose();
  };

  useEffect(() => {
    if (user) {
      setForm({ ...user });
    }
  }, [user]);

  return (
    <PopupModal
      onClose={onClose}
      contentClassName="w-[500px] mx-auto relative"
      containerClassName="!z-[100]"
      shouldStopPropagation={false}
    >
      <button
        onClick={onClose}
        className="absolute top-2 -right-6 [&_path]:stroke-white"
      >
        <CloseIcon />
      </button>
      <div className="text-black text-lg font-normal poppins">
        {user?.id ? "Edit" : "Add"} a user type
      </div>
      <div className="flex flex-col gap-4 max-h-[400px] overflow-y-auto">
        <div>
          <div className="mt-4">
            <div className="text-black mb-2 text-[13px] font-normal font-['Poppins'] leading-[18.20px]">
              User type
            </div>
            <div className="flex flex-wrap gap-3 items-center">
              <div className="w-full flex items-center">
                <RadioButton
                  name="userType"
                  options={[
                    { label: "User", value: "U" },
                    { label: "Stylist", value: "ST" },
                    { label: "Salon", value: "SA" },
                  ]}
                  className="h-[41px] p-2.5 flex-1 rounded-lg border border-[#dddddd] justify-start items-center gap-2 flex"
                  selectedValue={form?.userType}
                  containerClassName="!flex-row w-full"
                  onChange={(value) => {
                    setForm({
                      ...form,
                      userType: value,
                    });
                  }}
                />
              </div>
            </div>
          </div>

          <div className="mt-4">
            <Button
              variant="primary"
              loading={loading}
              disabled={loading}
              className="w-full"
              onClick={handleSubmit}
            >
              {user?.id ? "Update" : "Add"}
            </Button>
          </div>
        </div>
      </div>
    </PopupModal>
  );
}
